import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { ProjectIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';

import { IDrawer } from '../../../PublicationContent';
import './styled';
import {
  DataTypeProjectIconContainer,
  DataTypeProjectPillText,
  DataTypeProjectPillWrapper,
} from './styled';

export const dataTypeProjectContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node.querySelectorAll('[data-type="projects"], [data-type="project"]').forEach((project) => {
    const slug = project.getAttribute('data-slug');
    const name = project.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypeProjectPill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDrawer({ show: true, slug, type: 'projects' });
    });

    project.replaceWith(template.firstChild);
  });
};

interface DataTypeProjectPillProps {
  name: string;
}

export const DataTypeProjectPill = ({ name }: DataTypeProjectPillProps) => {
  return (
    <DataTypeProjectPillWrapper>
      <DataTypeProjectIconContainer>
        <ProjectIcon width={16} height={16} fill={'var(--color-data-project-foreground)'} />
      </DataTypeProjectIconContainer>
      <DataTypeProjectPillText>{name}</DataTypeProjectPillText>
    </DataTypeProjectPillWrapper>
  );
};
